
const MIN_WIDTH = 160;

export class HtmlAreaToolbarManager {
	constructor(layout, extraTools) {
		this.layout = layout;
		this.movingCallback = (e) => window.requestAnimationFrame(this.editorMoved.bind(this));
		this.extraTools = extraTools;

		/**
		 * Flag used to ignore blur events (the toolbar will be visible even on long blur because focus is expected to return)
		 * @type {boolean}
		 */
		this.frozen = false;
	}

	/* Called when text area is receive focus */
	focus(editor) {
		if (this.closeTimeout) {
			// Just cancel previous timed hiding
			window.clearTimeout(this.closeTimeout);
			this.closeTimeout = 0;
		} else this.showFor(editor);
	}

	/* Called when text area is lost focus */
	blur() {
		this.closeTimeout = window.setTimeout(()=> {
			this.closeTimeout = 0;
			this.hide();
		}, 200);
	}

	install() {
		if (!this.container) {
			this.container = this.create();
			document.body.append(this.container);
			this.editorMoved();	// position the toolbar
			window.addEventListener('resize', this.movingCallback);
			document.addEventListener('scroll', this.movingCallback);
		}
	}

	uninstall() {
		if (this.container) {
			document.body.removeChild(this.container);
			delete this.container;
			window.removeEventListener('resize', this.movingCallback);
			document.removeEventListener('scroll', this.movingCallback);
		}
	}

	isInstalled() {
		return !!this.container;
	}

	editorMoved() {
		if (this.editor) {
			const editorRec = this.editor.getBoundingClientRect();
			this.container.style.maxWidth = Math.max(editorRec.width, MIN_WIDTH) + "px";
			const toolbarRec = this.container.getBoundingClientRect();
			this.container.style.top = Math.max(editorRec.top + window.scrollY - toolbarRec.height, window.scrollY) + "px";
			this.container.style.left = Math.max(editorRec.left + window.scrollX, window.scrollX) + "px";
		}
	}

	create() {
		const container = document.createElement("div");
		container.className = "html-toolbar";
		this.createButtons(container);
		return container;
	}

	showFor(editor) {
		this.editor = editor;
		this.install();
	}

	hide() {
		this.uninstall();
		if (this.editor) {
			this.editor.toolbarGone();
			delete this.editor;
		}
	}

	createButtons(container) {
		container.append(
			this.createButton("bold", "edit-bold")
			,this.createButton("italic", "edit-italic")
			,this.createButton("underline", "edit-underline")
			,this.createButton("strikeThrough", "edit-strike")
			,this.createSeparator()
			,this.createButton("insertOrderedList", "edit-ol")
			,this.createButton("insertUnorderedList", "edit-ul")
			,this.createSeparator()
			,this.createButton("createLink", "edit-link")
			,this.createButton("unlink", "edit-unlink")
			,this.createButton("clickable", "click", this.editor.clickable)
		);
		if (this.extraTools && this.extraTools.length > 0) {
			for (let tool of this.extraTools) {
				if (typeof tool === "string") {
					if (tool.length === 0) container.append(this.createSeparator());
				} else {
					container.append(this.createButton(tool.name, tool.icon, !!tool.switchedOn, tool.label));
				}
			}
		}
	}

	createButton(name, icon, switchOn, label) {
		const button = document.createElement("button");
		button.setAttribute("data-command", name);
		button.setAttribute("type", "button");
		button.className = "toolbar-button";
		const icn = document.createElement("f-icon");
		icn.setAttribute("name", icon);
		button.append(icn);
		if (label) button.append(document.createTextNode(" " + label));
		if (switchOn) button.classList.add("switched-on");
		button.addEventListener("click", ev => {
			this.editor.focus();	// re-focus after clicking
			this.editor.toolbarAction(name);
		});
		return button;
	}

	createSeparator() {
		return document.createElement("span");
	}

	changeLayout(newValue) {
		if (newValue !== this.layout) {
			const inst = this.isInstalled();
			this.uninstall();
			this.layout = newValue;
			if (inst) this.install();
		}
	}

	setSwitch(name, value) {
		if (this.isInstalled()) {
			const found = this.container.querySelector("button[data-command="+name+"]");
			if (found) {
				if (value) found.classList.add("switched-on");
				else found.classList.remove("switched-on");

			}
		}
	}
}
